'use client';
import { useEffect, useState } from 'react';

/**
 * Legacy screen size hook restored from the removed `@smartproxy-web/shared/hooks`
 * package. Unlike `useScreenSize`, it has a tablet tier (481-768px) where
 * `isDesktop` is false, which some consumers (e.g. AccordionList auto-rotation)
 * rely on. TODO: consolidate with `useScreenSize` and remove this hook.
 */
export function useScreenSizeLegacy() {
  const [screen, setScreen] = useState<'mobile' | 'tablet' | 'desktop'>(
    'desktop'
  );

  function handleWindowSizeChange() {
    const screens = {
      desktop: 1440,
      tablet: 768,
      mobile: 480,
    };

    const width = window.innerWidth;
    if (width <= screens.mobile) {
      setScreen('mobile');
    } else if (width <= screens.tablet) {
      setScreen('tablet');
    } else {
      setScreen('desktop');
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return {
    isMobile: screen === 'mobile',
    isTablet: screen === 'tablet',
    isDesktop: screen === 'desktop',
    notMountedScreen: !screen,
  };
}
